import { getEmailWorkFlow } from "../../../../../actions/Utilities/EmailWorkFlow";
import { useQuery } from "react-query";

export default function useEmailWorkFlow() {
  return useQuery("GetEmailWorkFlow", getEmailWorkFlow, {
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
}
